import { render, staticRenderFns } from "./courseImport.vue?vue&type=template&id=50b8dd1a"
import script from "./courseImport.vue?vue&type=script&lang=js"
export * from "./courseImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports